module.exports = __webpack_public_path__ + "img/28.9f74ce44.jpg";